import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLibraryFlashStore = defineStore('library-flash', () => {
  const message = ref<{ libraryItemID: string; text: string }>();

  function show(libraryItemID: string, text: string) {
    message.value = { libraryItemID, text };
  }

  function take(libraryItemID: string): string {
    if (message.value?.libraryItemID !== libraryItemID) return '';
    const text = message.value.text;
    message.value = undefined;
    return text;
  }

  return { message, show, take };
});
